export default __webpack_public_path__ + "static/41-e0326ffe1453d0ef172b71c992fe5dbf.png";